import {ActionTypes} from "./type";

export const globalIdAction = (id) => async (dispatch) => {
    dispatch({
        type: ActionTypes.SET_GLOBAL_ID,
        payload: id
    });
};

